function checkIfClouldinaryUrl(url) {
  return url ? url.search("res.cloudinary.com") > 0 : false
}

export function resizeImageIfCloudinary(url, crop_width, crop_height = -1, width = -1, height = -1, webp = false) {
  if (checkIfClouldinaryUrl(url)) {
    const parts = url.split("/")
    const addstring = `w_${crop_width}${crop_height > 0 ? ",h_" + crop_height : ""},c_fill`
    const addString2 = addstring + (width > 0 ? `/w_${width},h_${height},c_fit` : "") + ('/q_auto:best');
    const outputParts = parts.reduce((cumulate, part) => part === "upload" ? [...cumulate, part, addString2] : [...cumulate, part], [])
    const dotParts = outputParts.join("/").split(".")
    const dotPartsShift = dotParts.reduce((cumulate, part) => webp && ["png", "jpeg", "jpg"].includes(part) ? [...cumulate, "webp"] : [...cumulate, part], [])
    return dotPartsShift.join(".")
  }
  return url

}

export function changeImageQualityIfCloudinary(url, quality) {
  if (checkIfClouldinaryUrl(url)) {
    const parts = url.split("/")
    parts.splice(parts.indexOf("upload") + 1, 0, `q_auto:${quality}`)
    return parts.join("/")
  }
  return url
}